module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_1_493892ae91be6cc91afb882cd1317b6b.png";